module.exports = __webpack_public_path__ + "media/images/clubs-logo-ef02335c8c51da6f2e8b35d90cc9934e.png";